import { CellStyle, ColDef } from '@ag-grid-community/core';

const makeParamRoute =
  (route: string) =>
  (params?: string | number | null, isChildRoute?: boolean): string => {
    const routePrefix = isChildRoute ? '' : `${route}/`;
    return params ? `${routePrefix}${params}` : route;
  };

export const ROUTES = {
  base: '/',
  login: '/login',
  feed: '/feed',
  markets: '/markets',
  customPage: makeParamRoute('/page'),
  search: '/search',
  globalFeed: '/feed/global',
  myContent: '/my-content',
  article: makeParamRoute('/articles'),
  companies: makeParamRoute('/company-list'),
  company: makeParamRoute('/companies'),
  municipal: makeParamRoute('/municipals'),
  sectors: makeParamRoute('/feed/global/sectors'),
  specialSituations: '/special-situations',
  dashboards: makeParamRoute('/dashboards'),
  notFound: '/404',
  redirect: '/redirect',
  logout: '/logout',
  unauthorized: '/401',
  download: '/download',
  genieStandalone: '/genie',
};

export const COMPANY_ROUTES = {
  recentlyPublished: 'recently-published',
  deals: 'deals',
  loans: makeParamRoute('deals/loans'),
  bonds: makeParamRoute('deals/bonds'),
  documents: 'documents',
  bondsDocuments: 'bonds',
  loansDocuments: 'loans',
  filingsDocuments: 'filings',
  risk: 'risk',
  dockets: 'dockets',
  financials: 'financials',
};

export const MY_CONTENT_ROUTES = {
  articles: makeParamRoute('articles'),
  watchlists: makeParamRoute('watchlists'),
  searches: 'searches',
  covenants: 'covenants',
  managePreferences: 'interests',
  internalEmailPrefrences: 'email-preferences',
};

export const EXTERNAL_ROUTES = {
  onboarding: '/user/onboarding',
  analysts: makeParamRoute('/analysts'),
  rpCalculator: '/rp-calculator',
  externalEmailPrefrences: '/user/email-preferences',
};

export const FEED_BATCH_SIZE = 50;
export const HIDE_PAGINATION_VALUE = 10;
export const DEFAULT_DEBOUNCE_RATE = 300;

export const NO_DATA = '--';

export type DateType = Date | null;

export const EM_DASH = '—';

export const GENERIC_ERROR_TEXT = 'Oops! Something went wrong. Please try again';
export const COPY_WATCHLIST_SUCCESS = 'Your watchlist was successfully copied';
export const COPY_WATCHLIST_ERROR =
  'There was an error while trying to copy your watchlist. Please check is the name is unique,';

export const EXPORT_EXCEL_SHEET_NAME = 'CreditSights';

export const AG_TABLE_RIGHT_ALIGNED_COLUMN_DEF: Partial<ColDef> = {
  cellStyle: (): CellStyle => ({ textAlign: 'right' }),
  cellClass: 'rightAligned',
};
